import { Formik, Form, Field } from 'formik';
import React from 'react';

import Button, {
  ButtonSize,
  ButtonType
} from 'legacy/common/components/button/Button';
import { PayoutBank as PayoutBankDto } from 'legacy/events/types';

import getBankLabel from '../../helpers/getBankLabel';

import styles from 'legacy/common/components/form/Form.module.scss';

type Props = {
  banks: {
    hostBanks: PayoutBankDto[];
    associationsBanks: PayoutBankDto[];
  };
  currentSelection: PayoutBankDto;
  onSubmit: (data: { bank: string }) => void;
  onCancel: () => void;
  isLoading: boolean;
};

const DestinationForm: React.FC<Props> = ({
  banks,
  currentSelection,
  onSubmit,
  onCancel,
  isLoading
}) => {
  const initialValues = {
    bank: currentSelection?.stripeId || ''
  };

  return (
    <Formik initialValues={initialValues} onSubmit={onSubmit}>
      <Form>
        <Field className={styles.select} as="select" id="bank" name="bank">
          <option key="default" value="">
            Use default
          </option>
          <optgroup label="Host banks">
            {banks.hostBanks.map((bank) => (
              <option key={bank.id} value={bank.stripeId}>
                {getBankLabel(bank)}
              </option>
            ))}
          </optgroup>
          {banks.associationsBanks.length > 0 && (
            <optgroup label="Association banks">
              {banks.associationsBanks.map((bank) => (
                <option key={bank.id} value={bank.stripeId}>
                  {getBankLabel(bank)}
                </option>
              ))}
            </optgroup>
          )}
        </Field>
        <div className="flex justify-between items-center mt-3 gap-4">
          <Button
            size={ButtonSize.Small}
            loading={isLoading}
            type={ButtonType.Secondary}
            onClick={onCancel}
          >
            Cancel
          </Button>
          <Button
            size={ButtonSize.Small}
            isSubmit
            loading={isLoading}
            type={ButtonType.Primary}
          >
            Save
          </Button>
        </div>
      </Form>
    </Formik>
  );
};

export default DestinationForm;
